// Shared content/data for Cassie Gee Investments site

export const COMPANY = {
  name: "Cassie Gee Investments CC",
  shortName: "Cassie Gee",
  reg: "2003/034426/23",
  established: 2003,
  yearsInBusiness: new Date().getFullYear() - 2003,
  director: "Casper Garise",
  phones: ["+27 79 540 2898"],
  whatsapp: "27795402898",
  emails: ["info@cassiegee.com"],
  address: "5 Myrtle Street, Clydesdale, Pretoria, 0002",
  poBox: "PO Box 11969, The Tramshed, 0126",
  hours: ["Monday – Friday: 08:00 – 17:00", "Saturday: 08:00 – 13:00"],
  socials: {
    linkedin: "https://www.linkedin.com/",
    facebook: "https://www.facebook.com/",
  },
};

const WHATSAPP_QUOTE_MESSAGE =
  "Hi Cassie Gee Investments, I'd like to request a quote. Please assist with:\n\n• Product/materials needed: \n• Quantity: \n• Delivery location: ";

export const whatsappLink = (message = WHATSAPP_QUOTE_MESSAGE) =>
  `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(message)}`;

// Trusted suppliers / clients — real logos where provided
export const TRUSTED_SUPPLIERS = [
  {
    name: "Build It",
    tagline: "Building Supplies",
    logo: "https://customer-assets.emergentagent.com/job_cassiegee-build/artifacts/780k4bzx_built%20it.png",
  },
  {
    name: "Mica",
    tagline: "Let us show you how",
    logo: "https://customer-assets.emergentagent.com/job_cassiegee-build/artifacts/lzo1az6b_mica.jfif",
  },
  {
    name: "SI Hardware",
    tagline: "Building Supplies at Best Prices",
    logo: "https://customer-assets.emergentagent.com/job_cassiegee-build/artifacts/sx59ff5d_si.jfif",
  },
  {
    name: "Dada's World of Hardware",
    tagline: "Hardware Retail",
    logo: "https://customer-assets.emergentagent.com/job_cassiegee-build/artifacts/2uiedng9_dadas.jfif",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/what-we-supply", label: "What We Supply" },
  { to: "/for-contractors", label: "For Contractors" },
  { to: "/export-import", label: "Export & Import" },
  { to: "/renovation-construction", label: "Renovation" },
  { to: "/clients", label: "Clients" },
  { to: "/contact", label: "Contact" },
];

// Hero video — Pexels CDN, active large-scale construction site (no people in offices)
// Primary: ID 5674342 "Time lapse of a construction site" — cranes, concrete pour, scaffolding, workers
// Fallback: ID 6033941 "Top view of a construction site" — aerial cranes + multi-storey build
export const HERO_VIDEO =
  "https://videos.pexels.com/video-files/5674342/5674342-hd_1920_1080_30fps.mp4";
export const HERO_VIDEO_FALLBACK =
  "https://videos.pexels.com/video-files/6033941/6033941-hd_1920_1080_30fps.mp4";

// Specific industrial / construction Unsplash photos — each tied to the section
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1800&q=80&auto=format&fit=crop",
  heroPoster: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1800&q=80&auto=format&fit=crop",
  warehouse: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1600&q=80&auto=format&fit=crop",
  warehouseAlt: "https://images.unsplash.com/photo-1565891741441-64926e441838?w=1600&q=80&auto=format&fit=crop",
  hardware: "https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=1400&q=80&auto=format&fit=crop",
  cement: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=1400&q=80&auto=format&fit=crop",
  cementBags: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=1400&q=80&auto=format&fit=crop",
  mining: "https://images.unsplash.com/photo-1542621334-a254cf47733d?w=1400&q=80&auto=format&fit=crop",
  miningAlt: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?w=1400&q=80&auto=format&fit=crop",
  heavy: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=1400&q=80&auto=format&fit=crop",
  heavyAlt: "https://images.unsplash.com/photo-1605152276897-4f618f831968?w=1400&q=80&auto=format&fit=crop",
  steel: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=1400&q=80&auto=format&fit=crop",
  steelStructure: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1600&q=80&auto=format&fit=crop",
  roofing: "https://images.unsplash.com/photo-1605152276897-4f618f831968?w=1400&q=80&auto=format&fit=crop",
  contractor: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1600&q=80&auto=format&fit=crop",
  contractorAlt: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1600&q=80&auto=format&fit=crop",
  exportShip: "https://images.unsplash.com/photo-1605745341112-85968b19335b?w=1600&q=80&auto=format&fit=crop",
  exportTruck: "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?w=1400&q=80&auto=format&fit=crop",
  exportContainers: "https://images.unsplash.com/photo-1605745341112-85968b19335b?w=1600&q=80&auto=format&fit=crop",
  exportPort: "https://images.unsplash.com/photo-1577086664693-894d8405334a?w=1600&q=80&auto=format&fit=crop",
  pretoria: "https://images.unsplash.com/photo-1577086664693-894d8405334a?w=1600&q=80&auto=format&fit=crop",
  // Renovation work (all in-progress)
  renoKitchen: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1400&q=80&auto=format&fit=crop",
  renoBath: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1400&q=80&auto=format&fit=crop",
  renoFoundation: "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?w=1400&q=80&auto=format&fit=crop",
  renoCommercial: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=1400&q=80&auto=format&fit=crop",
  renoRoof: "https://images.unsplash.com/photo-1605152276897-4f618f831968?w=1400&q=80&auto=format&fit=crop",
  renoExterior: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?w=1400&q=80&auto=format&fit=crop",
  meeting: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1400&q=80&auto=format&fit=crop",
  // Additional industrial / supply imagery
  forklift: "https://images.unsplash.com/photo-1601598851547-4302969d0614?w=1400&q=80&auto=format&fit=crop",
  steelYard: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=1400&q=80&auto=format&fit=crop",
  loadingDock: "https://images.unsplash.com/photo-1565891741441-64926e441838?w=1400&q=80&auto=format&fit=crop",
  craneSilhouette: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?w=1600&q=80&auto=format&fit=crop",
  brickWall: "https://images.unsplash.com/photo-1503387837-b154d5074bd2?w=1400&q=80&auto=format&fit=crop",
  workerHelmet: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1400&q=80&auto=format&fit=crop",
  // ─── Banner-quality + subsection imagery ───
  buildingMaterialsBanner: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1920&q=80&auto=format&fit=crop",
  subFoundation: "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?w=1200&q=80&auto=format&fit=crop",
  subRoofing: "https://images.unsplash.com/photo-1605152276897-4f618f831968?w=1200&q=80&auto=format&fit=crop",
  subTiles: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1200&q=80&auto=format&fit=crop",
  subDoors: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80&auto=format&fit=crop",
  subPaint: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=1200&q=80&auto=format&fit=crop",
  subBricks: "https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=1200&q=80&auto=format&fit=crop",
  miningBanner: "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?w=1920&q=80&auto=format&fit=crop",
  miningPPE: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1400&q=80&auto=format&fit=crop",
  commoditiesBanner: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=1920&q=80&auto=format&fit=crop",
  commoditiesForklift: "https://images.unsplash.com/photo-1601598851547-4302969d0614?w=1400&q=80&auto=format&fit=crop",
  exportHero: "https://images.unsplash.com/photo-1577705998148-6da4f3963bc8?w=1920&q=80&auto=format&fit=crop",
  exportQC: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1400&q=80&auto=format&fit=crop",
  exportPallet: "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1400&q=80&auto=format&fit=crop",
};

export const COUNTRIES = [
  "South Africa", "Malawi", "Zimbabwe", "Zambia", "Mozambique", "Botswana", "Namibia", "Other",
];

export const ROLES = [
  "Contractor", "Hardware Retailer", "Importer / Exporter",
  "Project Developer", "Mining Operator", "Individual", "Other",
];

export const NEEDS = [
  "Hardware Supply", "Building Materials", "Mining Equipment",
  "Heavy Equipment", "Commodities / Bulk", "Export Services",
  "Renovation & Construction", "Sourcing / Procurement", "General Enquiry",
];
